import React from "react";
import banner from "../../images/banner/banner.png";

export default function Banner() {

  return (    
    <section className="flat-section pt-0 flat-banner">
      <div className="container">
        <div className="wrap-banner bg-primary-new">
          <div className="box-left">
            <div className="box-title">
              <div className="text-subtitle text-primary">Become Partners</div>
              <h3 className="mt-4 fw-8">
                List your Properties on AskMeRealty, join Us Now!
              </h3>
            </div>
            <a
              href="#modalLogin"
              data-bs-toggle="modal"
              className="tf-btn btn-view primary size-1 hover-btn-view"
            >
              Sell Your Property <span className="icon icon-arrow-right2" />
            </a>
          </div>
          <div className="box-right">
            <img
              alt="image"
              src={banner}
              width={748}
              height={380}
            />
          </div>
        </div>
      </div>
    </section>
  );
}
